import { useState, useEffect, useCallback } from 'react';
import { Modal, Alert } from 'antd';
import { VGSCollectProvider } from '@vgs/collect-js-react';
import { loadVGSCollect } from '@vgs/collect-js';

import config from 'config';
import CvvFormContent from './CvvFormContent';

const CvvVerifyModal = ({ hide, ...modalProps }) => {
  const [initError, setInitError] = useState(null);
  const [isVGSLoaded, setIsVGSLoaded] = useState(false);
  const [loading, setLoading] = useState(false);
  const [submitHandler, setSubmitHandler] = useState(null);
  const [isFormValid, setIsFormValid] = useState(false);

  const handleFormSubmit = useCallback((submitFn, isValid) => {
    setSubmitHandler(() => submitFn);
    setIsFormValid(isValid);
  }, []);

  const handleLoadingChange = useCallback((isLoading) => {
    setLoading(isLoading);
  }, []);

  useEffect(() => {
    const loadVGS = async () => {
      if (modalProps.open && !isVGSLoaded) {
        try {
          await loadVGSCollect({
            vaultId: config.VGS_VAULT_ID,
            environment: config.VGS_ENV,
            version: '2.15.0',
          });
          setIsVGSLoaded(true);
          setInitError(null);
        } catch (error) {
          setInitError(
            'Failed to load VGS form. Please refresh and try again.',
          );
        }
      }
    };

    loadVGS();
  }, [modalProps.open, isVGSLoaded]);

  const renderModalContent = () => {
    if (initError) {
      return <Alert title={initError} type="error" />;
    }

    if (!isVGSLoaded) {
      return (
        <div style={{ padding: '20px', textAlign: 'center' }}>
          Loading secure form...
        </div>
      );
    }

    return (
      <VGSCollectProvider>
        <CvvFormContent
          hide={hide}
          modalProps={modalProps}
          setFormSubmitHandler={handleFormSubmit}
          onLoadingChange={handleLoadingChange}
        />
      </VGSCollectProvider>
    );
  };

  return (
    <Modal
      {...modalProps}
      data-testid="verify-cvv-modal"
      title="Verify CVV"
      destroyOnHidden={true}
      onCancel={hide}
      width={450}
      okText="Submit"
      okButtonProps={{
        disabled: !isFormValid,
        loading: loading,
      }}
      onOk={() => {
        if (submitHandler) {
          submitHandler();
        }
      }}
      confirmLoading={loading}
    >
      {renderModalContent()}
    </Modal>
  );
};

export default CvvVerifyModal;
